import { Helmet } from "react-helmet";
import ContactUsLayout from "../sections/contactUs/contactUsLayout";

const ContactUsPage = () => {
    return (
        <>
            <Helmet>
                <title>Contact code3x | AI, Games & Digital Solutions Experts</title>
                <meta name="description" content="code3x is here to listen. Reach out for AI expertise, immersive games, and digital innovation services." />
                <meta name="keywords" content="code3x, contact code3x, AI solutions, game development, digital solutions, leading tech company, Sri Lanka" />
                <link rel="canonical" href="https://code3x.tech/contact-us" />
            </Helmet>

            <ContactUsLayout />
        </>
    );
}

export default ContactUsPage;